export default __webpack_public_path__ + "static/media/add.570203fe.svg";